var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.88896 6.24559C3.46244 5.30835 6.62219 1.89937 8.87702 2.00228C9.55105 2.05741 10.1469 2.45987 10.631 2.92666C11.7426 3.99805 14.9247 8.05024 15.1053 8.90294C15.5447 10.9943 13.0199 12.1998 13.7926 14.3077C15.7625 19.0656 19.1569 22.4157 23.9794 24.3582C26.1132 25.1209 27.3346 22.6289 29.4535 23.0645C30.3156 23.2427 34.4231 26.3834 35.5086 27.4805C35.9797 27.9565 36.3893 28.5464 36.4452 29.2116C36.529 31.5547 32.8609 34.7175 32.1459 35.1218C30.459 36.3126 28.2581 36.2924 25.5751 35.0611C18.0881 31.9866 6.12318 20.3998 2.95041 12.7309C1.73641 10.0975 1.65262 7.91057 2.88896 6.24559Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.4136 4.31592L8.07687 8.21581",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.8552 29.8564L33.822 32.9169",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/CallIcon.d908f96f53cb8d9f6ff5219466b125b6.svg";
export { ForwardRef as ReactComponent };